import React, { memo } from 'react'

import UploadThreeDModelButton from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/UploadThreeDModelButton'

function InitialBannerState() {
  return (
    <div className="banner">
      <div className="banner__content">
        <img
          className="banner__icon"
          src="/assets/three_d_studio/initial_banner/cube.webp"
          alt=""
          aria-hidden="true"
          width="96"
          height="96"
        />
        <h2 className="banner__title cgt-heading-300">
          Your 3D Model will appear here
        </h2>
        <div className="banner__upload">
          <UploadThreeDModelButton withLabel />
        </div>
      </div>
    </div>
  )
}

export default memo(InitialBannerState)
